module.exports = __webpack_public_path__ + "img/purple-blue-dense.738d82ba.svg";